import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material';
import { Subscription } from "rxjs";

@Component({
  selector: 'app-currentplan',
  templateUrl: './currentplan.component.html',
  styleUrls: ['./currentplan.component.sass']
})
export class CurrentplanComponent implements OnInit {
  public tabActive = 'Mis Equipos y Servicios';
  public selectBan;
  public currentList;

  @Input() index;
  @Input() plan_name;
  @Input() quota_val;
  @Input() plan_val;
  @Input() plan_desc;
  @Input() rental_value;
  @Input() plac_eq;
  @Input() add_serv;
  @Input() equ_instal;
  @Input() desc_equ;
  @Input() plan_type;

  public SubscriberInfo = [];
  public token: string = sessionStorage.getItem("token");
  loadObserver: Subscription;
  public info = [];
  
  constructor(private router: Router, public dialog: MatDialog, private route: ActivatedRoute) { }

  ngOnInit() {
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    this.info = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo;
    this.selectBan = atob(sessionStorage.getItem("selectBan"));  
  }
}